import React, { useState, useEffect } from 'react';
import Header from '../Components/Header';
import Footer from '../Components/Footer';
import { Helmet } from 'react-helmet-async';
import Topmenuright from '../Components/Topmenuright';

import { useLocation } from 'react-router-dom';

function AddResult() {


  const subjectOptions = {
  "SLC (10th)": [
    "Alt. English",
    "Assamese (MIL)",
    "Hindi (MIL)",
    "Bengali (MIL)",
    "Bodo (MIL)",
    "English",
    "General Science",
    "General Mathematics",
    "Social Science",
    "History",
    "Hindi4",
    "Comp. Science",
    "Physical Education",
    "Geography"
  ],
  "SSLC (10+2) Arts": [
    "Alt. English",
    "Assamese (MIL)",
    "Hindi (MIL)",
    "Bengali (MIL)",
    "Bodo (MIL)",
    "English",
    "Political Science",
    "Economics",
    "Education",
    "History",
    "Logic &amp; Philosophy",
    "Comp. Science",
    "Fine Arts",
    "Geography"
  ],
  "SSLC (10+2) Commerce": [
    "Alt. English",
    "Assamese (MIL)",
    "Hindi (MIL)",
    "Bengali (MIL)",
    "Bodo (MIL)",
    "Banking",
    "English",
    "Economics",
    "Comp. Science",
    "Accountancy",
    "B. Studies",
    "Mathematics"
  ],
  "SSLC (10+2) Science": [   
    "Alt. English",
    "Assamese (MIL)",
    "Hindi (MIL)",
    "Bengali (MIL)",
    "Bodo (MIL)",
    "English",
    "Physics",
    "Chemistry",
    "Biology",
    "Mathematics",
    "Comp. Science"
  ]
};


  const [form, setForm] = useState({
    course: '',
    year_of_passing: '',
    session_type: '',
    candidate_name: '',
    regno: '',
    roll_no: '',
    number: '',
    father_name: '',
    grade: '',
    division: '',
    results: '',
    subjects: [
      { subject: '', tmarks: '', pmarks: '' }
    ]
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const location = useLocation();
  const [editId, setEditId] = useState(null);

  // Get id from query string
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get('id');
    if (id) {
      setEditId(id);
      setLoading(true);
      fetch(`https://sbsedelhi.com/backend/wp-json/custom/v1/mytable?regno=${encodeURIComponent(id)}`)
        .then(res => res.json())
        .then(data => {
          if (Array.isArray(data) && data.length > 0) {
            const result = data[0];
            setForm({
              course: result.course || '',
              year_of_passing: result.pyear || result.year_of_passing || '',
              session_type: result.session || '',
              candidate_name: result.name || '',
              regno: result.regno || '',
              roll_no: result.rollno || '',
              number: result.number || '',
              father_name: result.fname || result.father_name || '',
              grade: result.grade || '',
              division: result.division || '',
              results: result.result || '',
              subjects: result.subjects && Array.isArray(result.subjects) && result.subjects.length > 0
                ? result.subjects.map(subj => ({
                  subject: subj.subject || '',
                  tmarks: subj.tmarks || '',
                  pmarks: subj.pmarks || ''
                }))
                : [{ subject: '', tmarks: '', pmarks: '' }]
            });
          }
        })
        .catch(() => { })
        .finally(() => setLoading(false));
    }
  }, [location.search]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubjectChange = (idx, e) => {
    const newSubjects = form.subjects.map((subj, sidx) =>
      idx === sidx ? { ...subj, [e.target.name]: e.target.value } : subj
    );
    setForm({ ...form, subjects: newSubjects });
  };

  const addSubject = () => {
    setForm({ ...form, subjects: [...form.subjects, { subject: '', tmarks: '', pmarks: '' }] });
  };

  const removeSubject = (idx) => {
    setForm({ ...form, subjects: form.subjects.filter((_, sidx) => sidx !== idx) });
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);
  setSuccess('');
  setError('');

  try {
    let url = 'https://sbsedelhi.com/backend/wp-json/custom/v1/add-result';
    let method = 'POST';

    if (editId) {
      // For update mode
      url = `https://sbsedelhi.com/backend/wp-json/custom/v1/update-result`;
      method = 'POST';
    }

    const response = await fetch(url, {
      method,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        course: form.course,
        pyear: form.year_of_passing,
        session: form.session_type,
        name: form.candidate_name,

        // ✅ Send both old_regno (lookup) and regno (new)
        old_regno: editId,        // original regno (from query string)
        regno: form.regno,        // possibly updated regno from form

        rollno: form.roll_no,
        number: form.number,
        fname: form.father_name,
        grade: form.grade,
        division: form.division,
        result: form.results,
        subjects: form.subjects
      })
    });

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Failed (${response.status}): ${text}`);
    }

    setSuccess(editId ? 'Result updated successfully!' : 'Result saved successfully!');

    if (!editId) {
      setForm({
        course: '',
        year_of_passing: '',
        session_type: '',
        candidate_name: '',
        regno: '',
        roll_no: '',
        number: '',
        father_name: '',
        grade: '',
        division: '',
        results: '',
        subjects: [{ subject: '', tmarks: '', pmarks: '' }]
      });
    }
  } catch (err) {
    console.error(err);
    setError(editId ? 'Failed to update result.' : 'Failed to save result.');
  } finally {
    setLoading(false);
  }
};
  const isVisible = false; // or false


  return (
    <div>
      <Helmet>
        <title>Add Student Result</title>
      </Helmet>
      <Header />
      <div className='inner-main-navigation container'>
        <Topmenuright />
      </div>

      <div className="container main-contant">
        <div className="inner-page-container">
          <h1 className="page-title" style={{ textAlign: 'center', fontWeight: 700, marginBottom: 32, fontSize: 32, color: '#007bff' }}>{editId ? 'Update Student Result' : 'Add Student Result'}</h1>
          <form onSubmit={handleSubmit}>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 24, marginBottom: 24 }}>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Course*<br />
                  <select
                    name="course"
                    value={form.course}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: 10,
                      borderRadius: 6,
                      border: '1px solid #ccc',
                      fontSize: 16,
                    }}
                  >
                    <option value="">-- Select Course --</option>
                    <option value="SLC (10th)">SLC (10th)</option>
                    <option value="SSLC (10+2) Arts">SSLC (10+2) Arts</option>
                    <option value="SSLC (10+2) Commerce">SSLC (10+2) Commerce</option>
                    <option value="SSLC (10+2) Science">SSLC (10+2) Science</option>
                  </select>
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Years of Passing<br />
                    <input
                        type="number"
                        name="year_of_passing"
                        value={form.year_of_passing}
                        onChange={handleChange}
                        required
                        min="1950"
                        max="2099"
                        placeholder="YYYY"
                        style={{
                          width: '100%',
                          padding: 10,
                          borderRadius: 6,
                          border: '1px solid #ccc',
                          fontSize: 16,
                        }}
                      />
                    
                  <select
                    name="year_of_passing"
                    value={form.year_of_passing}
                    onChange={handleChange}
                    required={isVisible}  // only required when visible
                    style={{ display: isVisible ? 'block' : 'none',
                       width: '100%',
                      padding: 10,
                      borderRadius: 6,                   
                      border: '1px solid #ccc',
                      fontSize: 16
                    }}
                  
                  > <option value="">-- Select Year --</option>
                   <option value="2029">2029</option>
                    <option value="2028">2028</option>
                    <option value="2027">2027</option>
                    <option value="2026">2026</option>
                    <option value="2025">2025</option>
                    <option value="2024">2024</option>
                    <option value="2023">2023</option>
                    <option value="2022">2022</option>
                    <option value="2021">2021</option>
                    <option value="2020">2020</option>
                    <option value="2019">2019</option>
                    <option value="2018">2018</option>
                    <option value="2017">2017</option>
                    <option value="2016">2016</option>
                    <option value="2015">2015</option>
                    <option value="2014">2014</option>
                    <option value="2013">2013</option>
                  </select>              
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Session Type*<br />
                 <select
                    name="session_type" value={form.session_type}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: 10,
                      borderRadius: 6,
                      border: '1px solid #ccc',
                      fontSize: 16,
                    }}
                  >                 
                 	<option value="" selected="">Please fill out this field.</option>
	                <option value="Jan-June">Jan-June</option>
	                <option value="July-Dec">July-Dec</option>
                  </select>                
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Candidate Name*<br />
                  <input name="candidate_name" value={form.candidate_name} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Enrollment No.*<br />
                  <input name="regno" value={form.regno} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Roll No*<br />
                  <input name="roll_no" value={form.roll_no} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Number*<br />
                  <input name="number" value={form.number} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Father Name*<br />
                  <input name="father_name" value={form.father_name} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Grade*<br />
                  <input name="grade" value={form.grade} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500, width: '100%' }}>Division*<br />
                  <input name="division" value={form.division} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
              <div style={{ flex: '1 1 220px' }}>
                <label style={{ fontWeight: 500 }}>Results*<br />
                  <input name="results" value={form.results} onChange={handleChange} required style={{ width: '100%', padding: 10, borderRadius: 6, border: '1px solid #ccc', fontSize: 16 }} />
                </label>
              </div>
            </div>
            <div style={{ marginTop: 24 }}>
              <strong style={{ fontSize: 18, color: '#007bff' }}>Subjects</strong>
              <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 12, marginBottom: 12 }}>
                <thead>
                  <tr style={{ background: '#2a5db0', color: '#fff' }}>
                    <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Subject</th>
                    <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Theory Marks</th>
                    <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Practical Marks</th>
                    <th style={{ padding: 8, border: '1px solid #e0e0e0' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {form.subjects.map((subj, idx) => (
                    <tr key={idx}>
                      <td style={{ padding: 8, border: '1px solid #e0e0e0' }}>

                    <select
  name="subject"
  value={subj.subject}
  onChange={e => handleSubjectChange(idx, e)}
  required
  style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }}
>
  <option value="">-- Select Subject --</option>
  {subjectOptions[form.course]?.map((subjOption, i) => (
    <option key={i} value={subjOption}>
      {subjOption}
    </option>
  ))}
</select>                        
                      </td>
                      <td style={{ padding: 8, border: '1px solid #e0e0e0' }}>
                        <input name="tmarks" placeholder="Theory Marks" value={subj.tmarks} onChange={e => handleSubjectChange(idx, e)} required style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ padding: 8, border: '1px solid #e0e0e0' }}>
                        <input name="pmarks" placeholder="Practical Marks" value={subj.pmarks} onChange={e => handleSubjectChange(idx, e)} style={{ width: '100%', padding: 8, borderRadius: 4, border: '1px solid #ccc' }} />
                      </td>
                      <td style={{ padding: 8, border: '1px solid #e0e0e0', textAlign: 'center' }}>
                        <button type="button" onClick={() => removeSubject(idx)} disabled={form.subjects.length === 1} style={{ background: '#dc3545', color: '#fff', border: 'none', borderRadius: 4, padding: '6px 12px', cursor: form.subjects.length === 1 ? 'not-allowed' : 'pointer' }}>Remove</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button type="button" onClick={addSubject} style={{ background: '#007bff', color: '#fff', border: 'none', borderRadius: 6, padding: '10px 20px', fontSize: 16, fontWeight: 500, cursor: 'pointer' }}>Add Subject</button>
            </div>
            <div style={{ marginTop: 32, textAlign: 'center' }}>
              <button type="submit" disabled={loading} style={{ padding: '14px 40px', background: '#28a745', color: '#fff', border: 'none', borderRadius: 8, fontSize: 20, fontWeight: 600, cursor: 'pointer' }}>{loading ? (editId ? 'Updating...' : 'Saving...') : (editId ? 'Update Result' : 'Save Result')}</button>
            </div>
            {success && <div style={{ color: 'green', marginTop: 16, fontWeight: 500, textAlign: 'center', fontSize: 18 }}>{success}</div>}
            {error && <div style={{ color: 'red', marginTop: 16, fontWeight: 500, textAlign: 'center', fontSize: 18 }}>{error}</div>}
          </form>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AddResult;
